import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_openBlock(), _createBlock(_component_VueApexCharts, {
    options: _ctx.chartOptions,
    series: _ctx.series,
    height: _ctx.height
  }, null, 8, ["options", "series", "height"]))
}